import 'vendor/cocoon';
import 'vendor/easy-autocomplete';
import 'tempusdominus-bootstrap-4';
import Cleave from 'cleave.js';
import OnloadHandler from 'onload_handler';
import { WarehouseKind } from 'enumerations.js.erb';

(function () {

  const togglePersonBusiness = function(){
    var kind = $('#warehouse_kind').val();
    if (kind==WarehouseKind.COMPANY) {
      $('.company-warehouse').show();
      $('.subject-warehouse').val('').hide();
    } else if (kind==WarehouseKind.SUBJECT) {
      $('.company-warehouse').val('').hide();
      $('.subject-warehouse').show();
    } else {
      $('.company-warehouse').val('').hide();
      $('.subject-warehouse').val('').hide();
    }
  }

  const setupWarehouseForm = function(){
    $('#warehouse_kind').on('change', togglePersonBusiness);
    togglePersonBusiness();
  }

  OnloadHandler(function(){
    setupWarehouseForm();
  })


})()